// @flow

import React, { type Node } from 'react';
import ClickthroughLink from 'app/common/react/components/PinRep/components/ClickthroughLink';
import CloseupLink from 'app/common/react/components/PinRep/components/CloseupLink';
import getPinTypes from 'app/common/react/components/PinRep/utils/getPinTypes';
import { type Pin } from 'app/common/react/components/PinRep/types';

type Props = {|
  pin: Pin,
  children: Node,

  // Tracking Params (override TrackingParametersContext)
  componentType?: $Values<PCONST.thrift.ComponentType>,
  contextLogData?: Object,
  elementType?: $Values<PCONST.thrift.ElementType>,
  viewParameter?: $Values<PCONST.thrift.ViewParameterType>,
  viewType?: $Values<PCONST.thrift.ViewType>,
|};

export default function ClickthroughOrCloseupLink(props: Props) {
  const { pin } = props;
  const { isOneTap } = getPinTypes(pin);
  const ClickthroughOrCloseupLinkComponent = isOneTap ? ClickthroughLink : CloseupLink;

  return <ClickthroughOrCloseupLinkComponent {...props} />;
}
